import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableNewPartnerUserSetup = Loadable({
  loader: function loader() {
    return import('../NewPartnerUserSetup.jsx');
  },
  loading: ComponentLoading
});
export default LoadableNewPartnerUserSetup;